import { FC } from 'react';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';

import HeartEmpty from 'assets/png/heart-black.png?format=webp;avif&as=picture';
import HeartFilled from 'assets/png/heart-filled.png?format=webp;avif&as=picture';

interface IHeartsProps {
  wins: number;
  winsTo: number;
  prefix: string;
  opponent: boolean;
  heartsSize?: string;
}

const STANDART_COUNT = 3;

export const Hearts: FC<IHeartsProps> = ({ wins, winsTo, prefix, opponent, heartsSize }) => {
  let hearts = winsTo - wins;
  if (hearts <= 3)
    return (
      <div className="flex w-full flex-row-reverse justify-between gap-1 lg:gap-8">
        {Array.from({ length: STANDART_COUNT }).map((_, i) => {
          const heartsRemaining = winsTo - wins;
          const isFilled = i >= STANDART_COUNT - heartsRemaining;
          return (
            <OptimizedImage
              key={`${prefix}-${isFilled ? 'filled' : 'empty'}-${i}`}
              imageData={isFilled ? HeartFilled : HeartEmpty}
              alt={isFilled ? 'filled-heart' : 'empty-heart'}
              className={`h-[16px] w-[16px] sm:h-[26px] sm:w-[26px] ${heartsSize}`}
            />
          );
        })}
      </div>
    );
  return (
    <div className="flex w-full items-center justify-between gap-1 sm:gap-3 lg:gap-5">
      <OptimizedImage
        imageData={HeartFilled}
        alt={'filled-heart'}
        className={`h-[16px] w-[16px] sm:h-[26px] sm:w-[26px] ${heartsSize}`}
      />
      <p
        className={`leading-none sm:text-[36px] lg:text-[36px] ${opponent ? 'scale-x-[-1] transform' : ''}`}
      >
        {hearts}
      </p>
      <OptimizedImage
        imageData={HeartFilled}
        alt={'filled-heart'}
        className={`h-[16px] w-[16px] sm:h-[26px] sm:w-[26px] ${heartsSize}`}
      />
    </div>
  );
};
